<template>
  <v-card class="mb-3" style="border-radius: 10px;">
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 pa-0 text-xs-left text-sm-right px-1>
          <div class="font-weight-thin">
            <span @click="downloadCsv" class="nowrap subtitle rounded-chip mr-3">
              Download CSV
            </span>
            Registros: {{ config.records.length }}
          </div>
        </v-flex>
        <wire :record="record" v-for="record in config.records" :key="record.id" @onUpdateBankAccount="openUpdateBankAccountDialog" @onRetryCompanyWire="confirmRetryCompanyWire" @onMarkAsSuccess="confirmMarkAsSuccess" />
        <bank-account-dialog :addBtn="false" mode="update" :errors="errors" :record="bank_account_dialog_record" :dialog="bank_account_dialog" @closeDialog="closeBankAccountDialog" @updateBankAccount="updateBankAccount" />
        <confirm-modal :dialog="confirmation_dialog" :title="confirmation_title" @onCancel="confirmation_dialog = false" @onConfirm="onConfirm">
          Você tem certeza?
        </confirm-modal>

      </v-layout>
    </v-container>
    <v-card-actions>
      <v-layout column>
        <v-flex xs12>
          <v-btn v-if="showMoreBtn" @click="requestMoreRecords" block dark class="ma-0 btn-style">
            EXIBIR MAIS
          </v-btn>
          <v-btn v-if="config.selectable" block dark class="ma-0 btn-style--secondary mt-2" @click="selectableBtnClick">
            {{ config.selectable.btn_title }}
          </v-btn>
          <v-btn v-if="config.actionable" block dark class="ma-0 btn-style--tertiary mt-2" @click="actionableBtnClick">
            {{ config.actionable.btn_title }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>
<script>
import utils from "./shared/Utils"
import WireItem from "./WireItem"
import BankAccountsDialog from "./BankAccountsDialog"
import ConfirmModal from './ConfirmModal'

export default {
  name: 'WireList',
  components: { 'wire': WireItem, 'bank-account-dialog': BankAccountsDialog, 'confirm-modal': ConfirmModal },
  props: {
    config: {
      type: Object
    }
  },
  data() {
    return {
      bank_account_wire: null,
      confirmation_params: null,
      confirmation_title: '',
      confirmation_dialog: false,
      confirmation_wire: null,
      bank_account_dialog: false,
      errors: {},
      bank_account_dialog_record: {
        bank: { name: '', code: '' },
        branch_number: '',
        account_number: '',
        account_type: 'conta-corrente', // conta-corrente / poupanca
        owner_name: '',
        currency: null,
        owner_document_number: '',
        owner_document_type: 'cpf',
      },
      filter: ''
    }
  },
  computed: {
    showMoreBtn() {
      if ((this.config.records.length > 0) && (this.config.records.length % 100 == 0)) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    resetForm() {
      this.bank_account_dialog_record = {
        bank: { name: '', code: '', swift: '', ispb: '' },
        branch_number: '',
        account_number: '',
        account_type: 'conta-corrente', // conta-corrente / poupanca
        owner_name: '',
        currency: null,
        owner_document_number: '',
        owner_document_type: 'cpf',
      }
      this.errors = {}
    },
    openUpdateBankAccountDialog(wire) {
      let bank_account = wire.to_bank_account

      this.errors = {}
      if (bank_account.currency == 'BRL') {
        if (String(bank_account.owner_document_number).length == 14) {
          bank_account.owner_document_type = 'cnpj'
        } else {
          bank_account.owner_document_type = 'cpf'
        }
      } else {
        bank_account.account_type = 'internacional'
      }
      this.bank_account_dialog_record = bank_account
      this.bank_account_wire = wire
      this.bank_account_dialog = true
    },
    updateBankAccount() {
      let bank_account = this.bank_account_dialog_record
      if (bank_account.account_type == 'internacional') {
        bank_account.account_type = 'conta-corrente'
      }
      if (['BRL', 'MXN', 'COP'].includes(bank_account.currency)) {
        delete bank_account.bank.swift
      } else {
        delete bank_account.bank.code
      }

      let bank_account_payload = Object.fromEntries(Object.entries(this.bank_account_dialog_record).filter(([_, v]) => v != null))
      if (bank_account_payload.pix_info && bank_account_payload.pix_info.key == "" && bank_account_payload.pix_info.type == "") {
        delete bank_account_payload.pix_info
      }
      const payload = {
        bank_account: bank_account_payload
      }

      let successCallback = (response) => {
        if (response.body.data) {
          this.resetForm()
          this.bank_account_dialog = false
          this.$emit('disableCompanyWireActions', this.bank_account_wire)
        } else {
          console.log(response)
        }
      }

      let errorCallback = (response) => {
        if (response.body.errors) {
          let errors = utils.translateErrors(response.body.errors, this.$root.lang)
          this.$set(this, 'errors', errors)
          if (errors.bank && errors.bank.code) this.$set(this.errors, 'bank_code', errors.bank.code)
          if (errors.bank_id) this.$set(this.errors, 'bank_code', errors.bank_id)
          if (errors.bank && errors.bank.ispb) this.$set(this.errors, 'bank_ispb', errors.bank.ispb)
          if (errors.bank && errors.bank.swift) this.$set(this.errors, 'bank_swift', errors.bank.swift)
          if (errors.bank && errors.bank.name) this.$set(this.errors, 'bank_name', errors.bank.name)
          if (errors.code) this.$set(this.errors, 'bank_code', errors.code)
          if (errors.ispb) this.$set(this.errors, 'bank_ispb', errors.ispb)
        }
      }

      this.errors = {}
      const token = this.$cookies.get('api_token')
      const url = `${this.$root.urls.admin__company_wires}/${this.bank_account_wire.id}/update_bank_account`
      this.$http.put(url, payload, { headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
    },
    onConfirm() {
      this.confirmation_action(this.confirmation_params)
    },
    confirmRetryCompanyWire(wire) {
      this.confirmation_title = 'Refazer'
      this.confirmation_params = wire

      switch (wire.to_bank_account.currency) {
        case "MXN":
          this.confirmation_action = this.retrySPEI
          break;
        case "COP":
          this.confirmation_action = this.retryCobre
          break;
        default:
          this.confirmation_action = this.retryPix
          break;
      }

      this.confirmation_dialog = true
    },
    retryPix(wire) {
      const token = this.$cookies.get('api_token')
      const url = `${this.$root.urls.admin__company_wires}/${wire.id}/retry_pix`

      const successCallback = (response) => {
        this.$emit('disableCompanyWireActions', wire)
      }

      const errorCallback = (response) => {
        console.log(response)
      }

      this.confirmation_dialog = false
      this.$http.put(url, null, { headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
    },
    retrySPEI(wire) {
      const token = this.$cookies.get('api_token')
      const url = `${this.$root.urls.admin__company_wires}/${wire.id}/retry_spei`

      const successCallback = (response) => {
        this.$emit('disableCompanyWireActions', wire)
      }

      const errorCallback = (response) => {
        console.log(response)
      }

      this.confirmation_dialog = false
      this.$http.put(url, null, { headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
    },
    retryCobre(wire) {
      const token = this.$cookies.get('api_token')
      const url = `${this.$root.urls.admin__company_wires}/${wire.id}/retry_cobre`

      const successCallback = (response) => {
        this.$emit('disableCompanyWireActions', wire)
      }

      const errorCallback = (response) => {
        console.log(response)
      }

      this.confirmation_dialog = false
      this.$http.put(url, null, { headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
    },
    confirmMarkAsSuccess(wire) {
      this.confirmation_title = 'Marcar como sucesso'
      this.confirmation_params = wire
      this.confirmation_action = this.markAsSuccess
      this.confirmation_dialog = true
    },
    markAsSuccess(wire) {
      const token = this.$cookies.get('api_token')
      const url = `${this.$root.urls.admin__company_wires}/${wire.id}/mark_as_success`

      const successCallback = (response) => {
        this.$emit('disableCompanyWireActions', wire)
      }

      const errorCallback = (response) => {
        console.log(response)
      }

      this.confirmation_dialog = false
      this.$http.put(url, null, { headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
    },
    closeBankAccountDialog() {
      this.bank_account_dialog = false
    },
    selectableBtnClick() {
      this.config.selectable.btn_action()
    },
    actionableBtnClick() {
      this.config.actionable.btn_action()
    },
    requestMoreRecords(e) {
      if (this.config.loading == false) {
        this.$emit('loadMoreRecords', this.getLastRecordId())
      }
    },
    getLastRecordId() {
      let lastId = this.config.records.length - 1
      return this.config.records[lastId]['id']
    },
    downloadCsv() {
      const header_line = [
        'WIRE_ID',
        'VALUE',
        'STATUS',
        'DESTINATION_CURRENCY',
        'BANK_OWNER_NAME',
        'BANK_OWNER_DOCUMENT_TYPE',
        'BANK_OWNER_DOCUMENT_NUMBER',
        'PIX_TYPE',
        'PIX_KEY',
        'BANK_NAME',
        'BRANCH_NUMBER',
        'ACCOUNT_NUMBER',
        'ACCOUNT_TYPE',
        'ACCOUNT_COUNTRY',
        'ABA',
        'IBAN',
        'INTERMEDIARY_BANK_ACCOUNT_ID',
        'ROUTING_NUMBER',
        'BANK_CODE',
        'ISPB',
        'SWIFT',
        'COUNTRY',
        'DESTINATION_COMPANY_NAME',
        'DESTINATION_SOCIAL_NAME',
        'DESTINATION_PHONE_NUMBER',
        'DESTINATION_DOCUMENT_TYPE',
        'DESTINATION_DOCUMENT_NUMBER',
        'DESTINATION_FISCAL_COUNTRY',
        'APPROVED_BY',
        'PAYMENT_STARKINFRA',
        'DATE'
      ]

      const rows = this.config.records.reduce((acc, rawWire) => {
        const wire = JSON.parse(JSON.stringify(rawWire))
        const pixInfo = wire.to_bank_account.pix_info || {}
        const pixInfoType = pixInfo.type || ''
        const pixInfoKey = pixInfo.key || ''
        const row = [
          wire.id,
          wire.value,
          wire.status,
          wire.currency,
          utils.parseCommaField(wire.to_bank_account.owner_name),
          wire.to_bank_account.owner_document_type,
          utils.parseCommaField(wire.to_bank_account.owner_document_number),
          utils.parseCommaField(pixInfoType),
          pixInfoKey,
          utils.parseCommaField(wire.to_bank_account.bank.name),
          wire.to_bank_account.branch_number,
          utils.formatLargeNumberAsText(wire.to_bank_account.account_number),
          wire.to_bank_account.account_type,
          wire.to_bank_account.branch_country,
          wire.to_bank_account.aba,
          wire.to_bank_account.iban,
          wire.to_bank_account.intermediary_bank_account ? wire.to_bank_account.intermediary_bank_account.id : '',
          wire.to_bank_account.routing_number,
          utils.parseCommaField(wire.to_bank_account.bank.code),
          wire.to_bank_account.bank.ispb,
          wire.to_bank_account.bank.swift,
          wire.to_bank_account.bank.country,
          utils.parseCommaField(wire.to_bank_account.company.company_name),
          utils.parseCommaField(wire.to_bank_account.company.social_name),
          wire.to_bank_account.company.phone_number,
          wire.to_bank_account.company.document_type,
          utils.parseCommaField(wire.to_bank_account.company.document_number),
          utils.parseCommaField(wire.to_bank_account.company.fiscal_country),
          wire.user.name,
          wire.facilita_bank,
          utils.dbDateTimeToHuman(wire.inserted_at)
        ]

        acc.push(row)
        return acc
      }, [header_line])

      utils.exportToCsv('company_wire_transfers_report.csv', rows, ';')
    }
  }
}
</script>
<style>
.search-filter .v-icon {
  color: #CCC !important;
}

.search-filter .v-text-field__slot input {
  color: #AAA !important;
}
</style>



// WEBPACK FOOTER //
// src/WireList.vue